import styled, { css } from 'styled-components';

interface IStyledNumberInputProps {
  isContentWidth?: boolean;
  characterCount?: number;
}

export const StyledNumberInput = styled.input<IStyledNumberInputProps>`
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }

  width: 100%;
  text-align: center;
  padding: 0.5rem 0.4rem;
  box-sizing: border-box;
  background-color: ${Styles.color.white};
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  font-family: ${Styles.fontFamily.base};

  ${props =>
    props.isContentWidth &&
    css`
      width: calc(1.5rem + ${props.characterCount || 1}ch);
    `}
`;
